import React, { Component } from 'react';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { loaderStateTrue, loaderStateFalse } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../GlobalModules/Login/Actions/LoginAction';
import * as AdminGroupController from './Controller/GroupController';
//import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import ScaleLoader from "react-spinners/ScaleLoader";
import { DebounceInput } from 'react-debounce-input';
import AddEditUserGroupContent from "./Components/AddEditUserGroupContent";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import HomeUtility from '../../../../Home/Utility/Utility'
import Utility from '../../../../Utility/Utility';
import ContactGroupModalContent from './Components/GroupModalContent';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import ConfirmationAlert from '../../../../Utility/Components/ConfirmationAlert';
import UserGroupComponent from './Components/UserGroupComponent'
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Config from '../../../../Utility/Config';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import '../Assets/css/groupmanagementdoc.scss';
import '../Assets/css/groupmanagementresponsivedoc.scss';
import '../../../../Home/Assets/css/homeresponsivedoc.scss';
import '../../../../Home/Assets/css/homedoc.scss';
import Tooltip from 'react-bootstrap/Tooltip';
import UtilityGlobal from '../../../../GlobalModules/Utility/Utility';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
const lodash = require('lodash');

class UserGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkLimitNote: "",
            checkRulesPermission: "",
            //Group
            groupList: [],
            groupLimits: 15,
            groupOffsets: 0,
            hasMoreGroupList: false,
            //Member
            memberList: [],
            memberLimits: 17,
            memberOffsets: 0,
            hasMoreMemberList: false,

            selectedGroupId: "",

            //Contact
            allContact: true,
            clickedMemberData: {},

            //group add edit
            select_all_group_row: false,
            adminGroupModalFlag: false,
            name: "",
            name_error: "",
            editedId: "",
            editedFlag: false,
            getRowId: "",

            //user delete
            deleteUserModalFlag: false,

            //group delete
            deleteAdminGroupModalFlag: false,
            adminGroupDeleteObj: {},
            adminGroupDeleteBodySecondContent: "",
            columnFlag: "",

            //member
            selectedMemberRowId: "",

            //member add remove
            addRemoveModalFlag: false,
            zoominzoomoutflag: "",
            dataFor: "",
            contact_group_contact: [],
            remove_contact_group_contact_flag: false,
            remove_group_contact_arr: [],
            searchValue: "",
            getRowName: "",
            remove_contact_on_row_flag: false,
            row_customer_id: [],
            row_contact_group_id: "",

            searchMemberValue: "",
            adminGroupModalFlag: false,
            modalHeaderTitle: "",
            name: "",
            name_error: "",
            zoominzoomoutflag: "",
            editedFlag: false,
            editedId: "",
            nameBackUp: "",
            addNewContactFlag: false,

            showPopOver: false,
            showGroupContactPopOver: false,
            select_all_Unsubscribe_row: false,
            select_all_default_user: false,
            default_user_count: 0,
            windowWidth: 0,
            windowHeight: 0,
            contentHeight: 0,
            admin_group_mapping_row_data: [],
            editedFlagUser: false,
            editedIdUser: "",
            activeGroupRow: ""
        }
    }

    componentDidMount() {
        this.listAllGroups();
        this.checkTabInsideRole();
        this.fetchAllContact();
        this.tabSpaceFn();
        document.body.addEventListener('onclick', this.handleClickOutside.bind(this));
        this.getDimensions();
        window.addEventListener('resize', this.getDimensions);
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
        if (document.body) {
            document.body.removeEventListener('onclick', this.handleClickOutside.bind(this));
        }
        if (window) {
            window.removeEventListener('resize', this.getDimensions);
        }
    }
    handleClickOutside(event) {
        this.removeShowPopOver();

    }

    addNewKey = (obj, key, value) => {
        return { ...obj, [key]: value };
    }

    listAllGroups = () => {
        //console.log("listAllGroups load=========")
        const { loaderStateTrue, loaderStateFalse } = this.props;
        const { groupOffsets, groupLimits, groupList } = this.state;
        let promise = new Promise((resolve, reject) => {
            loaderStateTrue();
            let filters = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["offset"] = groupOffsets;
            globalQueryParamshash["limit"] = groupLimits;
            filters['filters'] = JSON.stringify(globalQueryParamshash);

            AdminGroupController.adminGroupsListing(filters).then((response) => {
                if (response.success) {
                    resolve(response)
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {

                }
            });
        })

        promise.then((res) => {
            if (res.total > 0 || res.data.length > 0) {
                this.setState({
                    hasMoreGroupList: true
                })
                if (groupOffsets <= res.total) {
                    let tempOffset = groupOffsets + groupLimits
                    this.setState({
                        groupOffsets: tempOffset
                    })
                    let tempAllGroupData = groupList.slice()
                    let newKeyArray = res.data.map(obj => this.addNewKey(obj, 'showPopOver', false));//New key add 		   
                    const finalGroupData = tempAllGroupData.concat(newKeyArray)
                    setTimeout(() => {
                        this.setState({ groupList: finalGroupData });
                    }, 500)
                } else {
                    this.setState({
                        hasMoreGroupList: false
                    })

                }
                if (res.data.length == 0) {
                    this.setState({
                        hasMoreGroupList: false
                    })
                }
            } else {
                this.setState({
                    groupList: [],
                    hasMoreGroupList: false
                })
            }


        })
    }

    showClosePopOver = (groupIdx, groupValue) => {
        const { groupList } = this.state;
        let tempGroupList = groupList.slice();
        //console.log("groupValue showClosePopOver=========",groupValue)
        let groupArry = []
        tempGroupList.map((value, idx) => {
            if (groupIdx == idx) {
                value['showPopOver'] = true;
            } else {
                value['showPopOver'] = false;
            }
            groupArry.push(value);
        })

        this.setState({
            groupList: groupArry,
            getRowName: groupValue.name
        }, () => {
            // console.log("groupList=========yyyyyyyyyyyy", this.state.groupList)
        });
    }

    groupListUi = () => {
        const { groupList, selectedGroupId } = this.state;
        let roleName = this.props.userCredentials.hasOwnProperty('user_details') && this.props.userCredentials.user_details && this.props.userCredentials.user_details.hasOwnProperty('user_type') && this.props.userCredentials.user_details.user_type;
        let arry = [];
        if (groupList.length > 0) {
            groupList.map((groupValue, groupIdx) => {
                // console.log("groupValue=====", groupValue)
                let active = "";
                //console.log("selectedGroupId========", selectedGroupId)
                //console.log("groupValue.id========", groupValue.id)
                if (selectedGroupId == groupValue.id) {
                    active = "active";
                }
                arry.push(
                    <div key={groupIdx} className={active + " " + "group_list_row"}>
                        <div className='group_list_row_content' onClick={() => { this.fetchAllGroupMembers(groupValue) }}>
                            {/* <span >{groupValue.name}</span> */}
                            {groupValue.name.length >= 20 ?
                                <OverlayTrigger overlay={<Tooltip>{groupValue.name}</Tooltip>} placement='right'>
                                    <span >{groupValue.name.length >= 20 && (groupValue.name).substring(0, 20) + "..."}</span>
                                </OverlayTrigger>
                                :
                                <span>{groupValue.name}</span>
                            }
                        </div>
                        <div className='group_list_row_count' data-tip={`Total users: ${groupValue.member_count}`}>{groupValue.member_count}
                            <ReactTooltip place="bottom" />
                        </div>
                        <div className='group_list_row_action'>
                            <div className="group_single_action">
                                {roleName != "user" ?
                                    <OverlayTrigger
                                        //show={groupValue.showPopOver}
                                        rootClose
                                        trigger="click"
                                        placement="bottom"
                                        overlay={
                                            <Popover className="group_single_action_inner action_popup_modal_group">
                                                <Popover.Content>
                                                    <div className="group_action_row">
                                                        <button className="group_action_btn_popup" onClick={() => { this.editAdminGroup(groupValue) }}>
                                                            <span className='group_action_btn_popup_icon'><i className="fa fa-pencil" ></i></span>
                                                            <span className='group_action_btn_popup_text'>Edit</span>
                                                        </button>
                                                        <button className="group_action_btn_popup" onClick={() => { this.deleteAdminGroup(groupValue) }}>
                                                            <span className='group_action_btn_popup_icon'><i className="fa fa-trash-o" ></i></span>
                                                            <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Delete</span></span>
                                                        </button>
                                                        <button className="group_action_btn_popup top_space" type='button' onClick={() => { this.addRemoveContactsFn(groupValue) }}><span className='group_action_btn_popup_icon'><img src={require('../../../../Utility/Public/images/add_trash.png')} className='group_remove_button_img' /></span><span className='group_action_btn_popup_text'>Add/Remove User</span></button>
                                                    </div>
                                                </Popover.Content>
                                            </Popover>
                                        }
                                    >
                                        <button className="group_action_btn" onClick={() => { this.showClosePopOver(groupIdx, groupValue) }}><i className="fa fa-ellipsis-v"></i></button>
                                    </OverlayTrigger>
                                    : null}
                            </div>
                        </div>
                    </div>
                )
            })
        }
        return arry;
    }

    getNextGroupData = () => {
        this.listAllGroups();
    }

    fetchAllGroupMembers = (groupValue) => {
        // alert();
        this.setState({
            selectedGroupId: groupValue.id,
            memberOffsets: 0,
            memberLimits: 17,
            allContact: false,
            memberList: [],
            selectedMemberRowId: "",
            select_all_group_row: false,

            getRowId: groupValue != "" ? groupValue.id : "",
            getRowIdStatus: groupValue != "" ? groupValue.id : "",
            getRowName: groupValue != "" ? groupValue.name : "",
            select_all_Unsubscribe_row: false,
            select_all_default_user: false,
            searchMemberValue: "",
            activeGroupRow: groupValue,
            clickedMemberData: {},
        }, () => {
            this.allGroupWiseMemberList();
        })
    }

    allGroupWiseMemberList = () => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        const { memberOffsets, memberLimits, memberList, searchMemberValue } = this.state;
        let promise = new Promise((resolve, reject) => {
            loaderStateTrue();
            let filters = {};
            let filter_op = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["offset"] = memberOffsets;
            globalQueryParamshash["limit"] = memberLimits;
            globalQueryParamshash["group_id"] = this.state.selectedGroupId;

            if (searchMemberValue.trim() != "") {
                globalQueryParamshash['search_attr'] = searchMemberValue.trim()
                filter_op = Object.assign(filter_op, { "search_attr": "substring" });
            }
            if (Object.keys(filter_op).length > 0) {
                filters["filter_op"] = JSON.stringify(filter_op);
            }

            filters['filters'] = JSON.stringify(globalQueryParamshash);

            AdminGroupController.getMembersList(filters).then((response) => {
                if (response.success) {
                    resolve(response)
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {

                }
            });
        })

        promise.then((res) => {
            if (res.total > 0 || res.data.length > 0) {
                this.setState({
                    hasMoreMemberList: true
                })
                if (memberOffsets <= res.total) {
                    let tempOffset = memberOffsets + memberLimits
                    this.setState({
                        memberOffsets: tempOffset
                    })
                    let tempAllMemberData = memberList.slice()
                    const finalMemberData = tempAllMemberData.concat(res.data)
                    setTimeout(() => {
                        this.setState({ memberList: finalMemberData });
                    }, 500)
                } else {
                    this.setState({
                        hasMoreMemberList: false
                    })

                }
                if (res.data.length == 0) {
                    this.setState({
                        hasMoreMemberList: false
                    })
                }
            } else {
                this.setState({
                    memberList: [],
                    hasMoreMemberList: false
                })
            }


        })
    }

    removeShowPopOver = () => {
        const { groupList } = this.state;
        let tempGroupList = groupList.slice();
        let newKeyArray = tempGroupList.map(obj => this.addNewKey(obj, 'showPopOver', false));
        this.setState({
            groupList: newKeyArray,
            showGroupContactPopOver: false
        })
    }

    fetchMembersDetails = (memberData) => {
        console.log('member data-------------->', memberData)
        let tempMemberData = { ...memberData }

        let temp_member_row_id = this.state.select_all_group_row ? tempMemberData.id : tempMemberData.user_id;

        this.setState({
            clickedMemberData: tempMemberData,
            selectedMemberRowId: temp_member_row_id,
            editedFlagUser: true,
            editedIdUser: this.state.select_all_group_row ? temp_member_row_id : tempMemberData.user_id,
        }, () => {

        })
    }

    deleteUserFn = () => {
        this.setState({
            deleteUserModalFlag: true,
        })
    }

    deleteUserConfirmationModalHide = () => {
        this.setState({
            deleteUserModalFlag: false,
        })
    }

    active_inactive_user = (e) => {
        loaderStateTrue();
        // console.log("Active Inactive", e)
        // console.log("Active Inactive", this.state.clickedMemberData)
        //create dataset MJ
        // do api call with 
        let data = {}
        data["status"] = e
        let id = this.state.selectedGroupId == "" ? this.state.clickedMemberData.id : this.state.clickedMemberData.user_id
        let type = "patch"
        AdminGroupController.userAddEdit(data, id, type).then((response) => {
            if (response.success) {
                Utility.toastNotifications(response.message, "Success", "success");
                loaderStateFalse();
                this.state.clickedMemberData["status"] = e
                this.resetDataAfterToggleChange(true);
                // this.listAllGroups();
                // this.fetchAllContact();
            }
            else {
                Utility.toastNotifications(response.message, "Error", "error")
                loaderStateFalse();
            }

        });
    }

    resetDataAfterToggleChange = (data) => {
        this.setState({
            //resert group
            groupList: [],
            groupLimits: 15,
            groupOffsets: 0,
            //resert member
            memberList: [],
            memberLimits: 17,
            memberOffsets: !data ? this.state.memberLimits - this.state.memberOffsets : 0,
        }, () => {
            this.listAllGroups();
            if (this.state.select_all_group_row) {
                this.fetchAllUserAdminData();
            } else {
                this.allGroupWiseMemberList();
            }
        })
    }

    userDeleteConfirmButton = () => {
        //this.userDeleteApi()
        const { clickedMemberData } = this.state;
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let data = {}
        // data['id'] = [clickedMemberData.id]
        data['id'] = this.state.selectedGroupId == "" ? [clickedMemberData.id] : [clickedMemberData.user_id]
        // console.log("data=======",data)
        // return false;
        AdminGroupController.userDelete(data).then((response) => {
            // console.log("response==========",response);
            if (response[0].success) {
                this.setState({
                    groupList: [],
                    groupLimits: 15,
                    groupOffsets: 0,
                    hasMoreGroupList: false,
                    memberList: [],
                    memberLimits: 17,
                    memberOffsets: 0,
                    hasMoreMemberList: false,
                    selectedGroupId: "",
                    select_all_group_row: true,
                    select_all_Unsubscribe_row: false,
                    select_all_default_user: false,
                }, () => {
                    this.fetchAllUserAdminData();
                    this.listAllGroups();
                    this.deleteUserConfirmationModalHide();
                    this.closeUserInfoFn();
                    this.resetContactGroupFrom();
                })
                Utility.toastNotifications("Deleted successfully", "Success", "success");
            } else {
                Utility.toastNotifications("Deleted not successfully", "Error", "error");
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
            this.deleteUserConfirmationModalHide();
        });
    }

    userDeleteCancleButton = () => {
        this.deleteUserConfirmationModalHide();
    }

    closeUserInfoFn = () => {
        this.setState({
            clickedMemberData: {},
            selectedMemberRowId: "",
        })
    }

    memberListUi = () => {
        let roleName = this.props.userCredentials.hasOwnProperty('user_details') && this.props.userCredentials.user_details && this.props.userCredentials.user_details.hasOwnProperty('user_type') && this.props.userCredentials.user_details.user_type;
        const { memberList, selectedMemberRowId, selectedGroupId, select_all_Unsubscribe_row, select_all_group_row } = this.state;
        let arry = [];
        if (memberList.length > 0) {
            memberList.map((memberValue, memberIdx) => {
                //console.log("memberValue========", memberValue)
                let active = ""

                let memberId = select_all_group_row ? memberValue.id : memberValue.user_id
                if (selectedMemberRowId == memberId) {
                    active = "active";
                }
                let active_inactive_label = ""
                if (!(memberValue.status)) {
                    active_inactive_label = "INACTIVE"
                }
                // let user_role = memberValue && memberValue.hasOwnProperty('UserOrgRelation') && memberValue.UserOrgRelation && memberValue.UserOrgRelation.length > 0 ? memberValue.UserOrgRelation[0].role_name : memberValue.user_type.charAt(0).toUpperCase() + memberValue.user_type.slice(1);
                let user_role = memberValue && memberValue.hasOwnProperty('user_type') && memberValue.user_type !== "" ? memberValue.user_type.charAt(0).toUpperCase() + memberValue.user_type.slice(1) : null;
                // let user_role = memberValue && memberValue?.UserOrgRelation.length > 0 ? memberValue?.UserOrgRelation[0].role_name : memberValue.user_type.charAt(0).toUpperCase() + memberValue.user_type.slice(1);
                arry.push(
                    <div key={memberIdx} className={active + " " + "member_list_row member_list_row_box"} >
                        <div className='usericon_row' onClick={() => { !select_all_Unsubscribe_row ? this.fetchMembersDetails(memberValue) : null }}>
                            {memberValue.profile_img_url != "" && memberValue.profile_img_url != null ?
                                <img src={JSON.parse(memberValue.profile_img_url).img_url} className='usericon_row_img' /> :
                                <img src={require('../../../../Utility/Public/images/usericon.png')} className='usericon_row_img' />}
                        </div>
                        <div className='member_list_row_content' onClick={() => { !select_all_Unsubscribe_row ? this.fetchMembersDetails(memberValue) : null }}>
                            {memberValue.first_name && memberValue.first_name != "" && memberValue.last_name && memberValue.last_name != "" && memberValue.user_type && memberValue.user_type != "" &&
                                <span className='member_list_row_inner member_name_label'>{memberValue.first_name + " " + memberValue.last_name + " (" + user_role + ")"}</span>}
                            <div className='phno_active_inactive_sec'>
                                {/* <span className='member_list_row_inner'>{memberValue.contact_number}</span> */}
                                <span className='member_list_row_inner'>{Utility.formatPhoneNumber(`${memberValue.contact_number}`)}</span>
                                <span className='active_inactive_sec'>{active_inactive_label}</span>
                            </div>
                        </div>
                        {selectedGroupId != "" && roleName != "user" ?
                            <div className='member_list_row_action'>
                                <button type='button' className='member_remove_button' data-tip='Remove user' onClick={() => { this.remove_member_on_row(memberValue) }}><img src={require('../../../../Utility/Public/images/dropcloseicon.png')} className='member_remove_button_img' /></button>
                                <ReactTooltip place="bottom" />
                            </div> : null}
                    </div>
                )
            })
        }
        return arry;
    }


    getNextMemberData = () => {
        if (this.state.allContact) {
            this.fetchAllUserAdminData();
        } else {
            this.allGroupWiseMemberList();
        }

    }

    fetchAllContact = () => {

        this.setState({
            selectedGroupId: "",
            memberOffsets: 0,
            memberLimits: 17,
            allContact: true,
            memberList: [],
            select_all_group_row: true,
            select_all_Unsubscribe_row: false,
            select_all_default_user: false,
            clickedMemberData: {},
            selectedMemberRowId: "",
        }, () => {
            this.fetchAllUserAdminData();
        })


    }

    fetchAllUnsubscribeContact = () => {
        const { select_all_Unsubscribe_row } = this.state

        this.setState({
            selectedGroupId: "",
            memberOffsets: 0,
            memberLimits: 17,
            allContact: true,
            memberList: [],
            select_all_Unsubscribe_row: true,
            select_all_group_row: false,
            selectedMemberRowId: ""
        }, () => {
            this.fetchAllUserAdminData();
        })
    }

    fetchAllDefaultUser = () => {
        this.setState({
            selectedGroupId: "",
            memberOffsets: 0,
            memberLimits: 17,
            allContact: true,
            memberList: [],
            select_all_group_row: true,
            select_all_Unsubscribe_row: false,
            select_all_default_user: true,
            clickedMemberData: {},
            selectedMemberRowId: "",
        }, () => {
            this.fetchAllUserAdminData();
        })
    }

    fetchAllUserAdminData = () => {
        const { loaderStateTrue, loaderStateFalse, userCredentials } = this.props;
        const { memberOffsets, memberLimits, memberList, searchMemberValue, select_all_Unsubscribe_row } = this.state;

        let roleName = this.props.userCredentials.hasOwnProperty('user_details') && this.props.userCredentials.user_details && this.props.userCredentials.user_details.hasOwnProperty('user_type') && this.props.userCredentials.user_details.user_type;

        let promise = new Promise((resolve, reject) => {
            loaderStateTrue();
            let filters = {};
            let filter_op = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["offset"] = memberOffsets;
            globalQueryParamshash["limit"] = memberLimits;
            if (roleName != "app_admin") {
                globalQueryParamshash['org_id'] = userCredentials.user_details.org_id;
                globalQueryParamshash["user_type"] = ['admin', 'staff'];
            }

            if (select_all_Unsubscribe_row) {
                globalQueryParamshash["is_subscribed"] = 0;
            }


            if (searchMemberValue.trim() != "") {
                globalQueryParamshash['search_attr'] = searchMemberValue.trim()
                filter_op = Object.assign(filter_op, { "search_attr": "substring" });
            }
            if (Object.keys(filter_op).length > 0) {
                filters["filter_op"] = JSON.stringify(filter_op);
            }

            filters['filters'] = JSON.stringify(globalQueryParamshash);

            AdminGroupController.getAllUserList(filters).then((response) => {
                if (response.success) {
                    resolve(response)
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {

                }
            });
        })

        promise.then((res) => {
            if (searchMemberValue.trim() == "") {
                this.setState({
                    default_user_count: res.total
                })
            }
            if (res.total > 0 || res.data.length > 0) {
                this.setState({
                    hasMoreMemberList: true
                })
                if (memberOffsets <= res.total) {
                    let tempOffset = memberOffsets + memberLimits
                    this.setState({
                        memberOffsets: tempOffset
                    })
                    let tempAllMemberData = memberList.slice()
                    const finalMemberData = tempAllMemberData.concat(res.data)
                    setTimeout(() => {
                        this.setState({ memberList: finalMemberData });
                    }, 500)
                } else {
                    this.setState({
                        hasMoreMemberList: false
                    })

                }
                if (res.data.length == 0) {
                    this.setState({
                        hasMoreMemberList: false
                    })
                }
            } else {
                this.setState({
                    memberList: [],
                    hasMoreMemberList: false
                })
            }


        })
    }

    tabSpaceFn = () => {
        // this.props.setTabConatinerSpaceClass("group_contact_inner_tab")
    }

    contactGroupModalfunction = () => {
        this.setState({
            adminGroupModalFlag: true,
            modalHeaderTitle: "Create Group",
            showPopOver: false,
            showGroupContactPopOver: false,
        })
    }

    resetContactGroupFrom = () => {
        this.setState({
            name: "",
            name_error: "",
            zoominzoomoutflag: "",
            adminGroupModalFlag: false,
            editedFlag: false,
            editedId: ""
        })
    }

    closeAdminGroupModal = () => {
        this.resetContactGroupFrom();
    }

    editAdminGroup = (params) => {
        //console.log("params==========", params)
        this.setState({
            modalHeaderTitle: "Edit Group",
            editedFlag: true,
            editedId: params.id,
            adminGroupModalFlag: true,
        }, () => {
            this.removeShowPopOver();
            this.setEditData(params);
        })
    }

    setEditData = (gridData) => {
        //console.log("setEditData gridData===========", gridData)
        this.setState({
            name: gridData.name
        })
    }

    handleChange = (event, type) => {
        //console.log("handleChange type==========", type)
        const { contactGroupFormData, contactGroupFormDataError } = this.state;

        if (type == "name") {
            if (event.target.value != "") {
                this.setState({
                    name: event.target.value,
                    name_error: "",
                    nameBackUp: event.target.value
                })
            } else {
                this.setState({
                    name: event.target.value,
                    name_error: "",
                    nameBackUp: event.target.value
                })
            }
        }

        this.setState({
        }, () => {
            //console.log("name handleChange===========", this.state.name)
            //console.log("name_error handleChange===========", this.state.name_error)
        })

    }

    validFormData = () => {
        let valid = true;
        if (this.state.name.trim() == "") {
            this.setState({
                name_error: "Required field"
            })
            valid = false;
        } else {
            this.setState({
                name_error: ""
            })
        }

        return valid;

    }

    formatingFormData = () => {

        let dataSet = [];
        let hash = {};
        hash['name'] = this.state.name.trim()
        dataSet.push(hash);
        //console.log("dataSet=========", dataSet)
        return dataSet;

    }

    saveAdminGroup = () => {
        let vaildData = this.validFormData();
        if (vaildData) {
            const { loaderStateTrue, loaderStateFalse } = this.props;
            const { editedFlag } = this.state;
            let dataset = this.formatingFormData();
            //return false;
            let type = 'post';
            let id = ""
            dataset = dataset;

            if (editedFlag) {
                id = this.state.editedId,
                    type = "patch";
                dataset = dataset[0];
            }
            //return false;
            loaderStateTrue();
            AdminGroupController.adminGroup(dataset, id, type).then((response) => {
                //console.log("createTemplate  response=========", response);
                loaderStateFalse();
                if (type == "post") {
                    if (response.length > 0) {
                        if (response[0].success) {
                            Utility.toastNotifications(response[0].message, "Success", "success");
                            this.setState({
                                groupList: [],
                                groupLimits: 15,
                                groupOffsets: 0,
                                hasMoreGroupList: false,
                                select_all_group_row: true,
                                selectedGroupId: "",
                                //resert member
                                memberList: [],
                                memberLimits: 17,
                                memberOffsets: 0,
                                hasMoreMemberList: false,
                                select_all_Unsubscribe_row: false,
                                select_all_default_user: false,
                            }, () => {
                                this.listAllGroups();
                                this.fetchAllUserAdminData();
                                this.closeAdminGroupModal();
                            })

                        } else {
                            Utility.toastNotifications(response[0].message, "Error", "error")
                            loaderStateFalse();
                        }
                    }
                } else {
                    if (response.success) {
                        //console.log("entry path call========")
                        this.setState({
                            groupList: [],
                            groupLimits: 15,
                            groupOffsets: 0,
                            hasMoreGroupList: false,
                        }, () => {
                            this.listAllGroups();
                            this.closeAdminGroupModal();
                        })
                        Utility.toastNotifications(response.message, "Success", "success");
                        loaderStateFalse();
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error")
                        loaderStateFalse();
                    }
                }


            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {

                }
            });
        }

    }

    deleteAdminGroup = (obj) => {
        //console.log("obj=========", obj)
        this.setState({
            deleteAdminGroupModalFlag: true,
            //actionModalflag: false,
            adminGroupDeleteBodySecondContent: obj.name,
            adminGroupDeleteObj: obj
        }, () => {
            this.removeShowPopOver();
        })
    }

    deleteConfirmationModalHide = () => {
        this.setState({
            deleteAdminGroupModalFlag: false,
            adminGroupDeleteBodySecondContent: "",
            adminGroupDeleteObj: {}
        })
    }

    adminGroupDeleteConfirmButton = () => {
        this.adminGroupDeleteApi()
    }

    adminGroupDeleteCancleButton = () => {
        this.deleteConfirmationModalHide();
    }

    adminGroupDeleteApi = () => {
        const { adminGroupDeleteObj } = this.state;
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let data = {}
        data['id'] = [adminGroupDeleteObj.id]
        //console.log("data==========", data)
        //return false;
        AdminGroupController.adminGroupDelete(data).then((response) => {
            if (response.success) {
                this.setState({
                    groupList: [],
                    groupLimits: 15,
                    groupOffsets: 0,
                    hasMoreGroupList: false,
                    memberList: [],
                    memberLimits: 17,
                    memberOffsets: 0,
                    hasMoreMemberList: false,
                    selectedGroupId: "",
                    select_all_group_row: true,
                    select_all_Unsubscribe_row: false,
                    select_all_default_user: false,
                }, () => {
                    this.fetchAllUserAdminData();
                    this.listAllGroups();
                    this.deleteConfirmationModalHide();
                    this.resetContactGroupFrom();
                })
                Utility.toastNotifications("Group deleted successfully", "Success", "success");
            } else {
                Utility.toastNotifications("Group deleted not successfully", "Error", "error");
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
            this.deleteConfirmationModalHide()
        });
    }

    addRemoveContactsFn = (parm) => {
        //console.log("parm=======", parm)
        this.setState({
            getRowId: parm.id
        }, () => {
            this.removeShowPopOver();
            this.addRemoveModalfunction()
        })

    }

    addRemoveModalfunction = () => {
        this.setState({
            addRemoveModalFlag: true,
            dataFor: "add_contacts",
            columnDefsContactGroup: [
                {
                    filter: "agTextColumnFilter",
                    headerName: "",
                    //field: "id",
                    maxWidth: 100,
                    minWidth: 100,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true,
                    server_side_filter: false,
                    server_side_sort: false,
                    lockPosition: true,
                },
                {
                    headerName: 'Name',
                    field: "first_name",
                    minWidth: 300,
                    lockPosition: true,
                    cellRenderer: (params) => {
                        if (params.data) {
                            let concatname = params.data.first_name + "" + params.data.last_name;
                            let logoUrl = params?.data?.hasOwnProperty('profile_img_url') && params?.data?.profile_img_url && JSON.parse(params.data.profile_img_url)
                            return (
                                <>
                                    <div className='group_view_profile_sec_grid_contact'>
                                        {params.data.profile_img_url ?
                                            <div className="gridusericon gridusericonBox">
                                                <img src={logoUrl.img_url} />
                                            </div>
                                            :
                                            <div className="default_user_img">
                                                <img src={require('../../../../Utility/Public/images/usericon.png')} />
                                            </div>
                                        }
                                        <div className='name_phno_sec'>
                                            {params.data.first_name && params.data.first_name && concatname.length > 15 ?
                                                <div className='name_sec'>
                                                    <span>
                                                        <OverlayTrigger overlay={<Tooltip>{params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}</Tooltip>}>
                                                            <span >
                                                                {params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}
                                                            </span>
                                                        </OverlayTrigger>
                                                    </span>
                                                </div>
                                                :
                                                <div className="name_sec">{params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}</div>
                                            }
                                            <div className='phno_sec'>{params.data.contact_number && Utility.formatPhoneNumber(`${params.data.contact_number}`)}</div>
                                        </div>
                                    </div>
                                </>
                            );
                        } else {
                            return null;
                        }
                    }
                },
                /* {
                    headerName: "",
                    field: "profile_img_url",
                    //width: 65,
                    maxWidth: 65,
                    //cellRenderer: 'loadingRenderer',
                    cellRenderer: (params) => {
                        if (params && params.data) {
                            if (params.data.profile_img_url) {
                                let logoUrl = JSON.parse(params.data.profile_img_url)
                                return <div className="gridusericon gridusericonBox">
                                    <img src={logoUrl.img_url} />
                                </div>
                            } else {
                                //return <img src="https://www.ag-grid.com/example-assets/loading.gif" />
                                return <div className='default_user_img'>
                                    <img src={require('../../../../Utility/Public/images/usericon.png')} />
                                </div>
                            }
                        } else {
                            return <img src="https://www.ag-grid.com/example-assets/loading.gif" />
                        }
                    }
                },
                {
                    headerName: 'Name',
                    field: "first_name",
                    minWidth: 300,
                    lockPosition: true,
                    cellRenderer: (params) => {
                        if (params.data) {
                            let concatname = params.data.first_name + "" + params.data.last_name
                            if (params.data.first_name && params.data.first_name && concatname.length > 15) {
                                return <div className="usercursor"><span className="textrenderview">
                                    <OverlayTrigger overlay={<Tooltip>{params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}</Tooltip>}>
                                        <span >
                                            {params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}
                                        </span>
                                    </OverlayTrigger>
                                </span></div>
                            } else {
                                return (<div className="usercursor"><span className="textrenderview">{params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}</span></div>)
                            }

                        } else {
                            return null;
                        }
                    },
                },
                {
                    headerName: "Phone number",
                    field: "contact_number",
                    minWidth: 200,
                    cellRenderer: (params) => {
                        if (params && params.data) {
                            if (params.data.contact_number) {
                                return <span>{Utility.formatPhoneNumber(`${params.data.contact_number}`)}</span>
                            } else {
                                return null;
                            }
                        } else {
                            return null;
                        }
                    }

                }, */
                {
                    headerName: "User Type",
                    field: "user_type",
                    minWidth: 200,
                    lockPosition: true,
                },

            ],
        })
    }

    closeAddRemoveModal = () => {
        this.setState({
            addRemoveModalFlag: false,
            contact_group_contact: [],
            admin_group_mapping_row_data: [],
            dataFor: "",
            getRowIdStatus: "",
            addContactSuccess: false,
            removeContactSuccess: false,

            //reset group list
            groupList: [],
            groupLimits: 15,
            groupOffsets: 0,
            hasMoreGroupList: false,

            //reset member lists
            memberList: [],
            memberLimits: 17,
            memberOffsets: 0,
            hasMoreMemberList: false,
            searchValue: ""
        }, () => {


            this.listAllGroups();
            this.fetchAllContact();
        })
    }

    zoominFunction = () => {
        //console.log("-----zoom in ------------")
        let zoominzoomoutflag = "zoominzoomoutclass"
        this.setState({
            zoominzoomoutflag: zoominzoomoutflag
        })
    }
    zoomoutFunction = () => {
        //console.log("-----zoom out ------------")
        let zoominzoomoutflag = ""
        this.setState({
            zoominzoomoutflag: zoominzoomoutflag
        })
    }

    showGridData = (type) => {
        //console.log("type=========", type)
        this.setState({
            dataFor: type,
            searchValue: ""
        })
    }

    onRowClicked = (e, parm) => {
        // Get the current selected rows
        const selectedRows = parm.getSelectedRows();
    
        // Preserve the existing selections from the state
        let updatedContactGroupContact = [...this.state.contact_group_contact];
        let updatedAdminGroupMappingRowData = [...this.state.admin_group_mapping_row_data];
    
        // Group ID to maintain mapping
        const groupId = this.state.getRowId;
    
        // Handle uncheck scenario (deselect rows)
        const deselectedRows = parm.getDisplayedRowAtIndex(e.node.rowIndex);
        if (!e.node.isSelected() && deselectedRows) {
            const deselectedUserId = deselectedRows.data.id;
            const deselectedUserIdRemove = deselectedRows.data.user_id;
    
            updatedContactGroupContact = updatedContactGroupContact.map(item => {
                if (item.group_id === groupId) {
                    return {
                        ...item,
                        user_id: item.user_id.filter(id => id !== deselectedUserId),
                    };
                }
                return item;
            }).filter(item => item.user_id.length > 0); // Remove group if no users are left
    
            updatedAdminGroupMappingRowData = updatedAdminGroupMappingRowData.map(item => {
                if (item.group_id === groupId) {
                    return {
                        ...item,
                        user_id: item.user_id.filter(id => id !== deselectedUserIdRemove),
                    };
                }
                return item;
            }).filter(item => item.user_id.length > 0); // Remove group if no users are left
        }
    
        // Process new selections (add rows)
        if (selectedRows.length > 0) {
            const userIds = selectedRows.map(row => row.id);
            const userIdRemoves = selectedRows.map(row => row.user_id);
    
            const contactGroupIndex = updatedContactGroupContact.findIndex(item => item.group_id === groupId);
            const adminGroupIndex = updatedAdminGroupMappingRowData.findIndex(item => item.group_id === groupId);
    
            if (contactGroupIndex > -1) {
                updatedContactGroupContact[contactGroupIndex].user_id = Array.from(
                    new Set([...updatedContactGroupContact[contactGroupIndex].user_id, ...userIds])
                );
            } else {
                updatedContactGroupContact.push({ group_id: groupId, user_id: userIds });
            }
    
            if (adminGroupIndex > -1) {
                updatedAdminGroupMappingRowData[adminGroupIndex].user_id = Array.from(
                    new Set([...updatedAdminGroupMappingRowData[adminGroupIndex].user_id, ...userIdRemoves])
                );
            } else {
                updatedAdminGroupMappingRowData.push({ group_id: groupId, user_id: userIdRemoves });
            }
        }
    
        // Update state with the merged selections
        this.setState({
            contact_group_contact: updatedContactGroupContact,
            admin_group_mapping_row_data: updatedAdminGroupMappingRowData,
        });
    };

    saveContactGroupContact = () => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        const { contact_group_contact } = this.state;
        //console.log("contact_group_contact add contact=======", contact_group_contact)
        if (contact_group_contact.length > 0) {
            var form = contact_group_contact
            //console.log("this.state.form===>", form)
            // return false;
            loaderStateTrue();
            AdminGroupController.contact_group_contact_create(form)
                .then((response) => {
                    if (response.length > 0) {
                        // console.log("response========", response)
                        if (response[0].success) {
                            this.setState({
                                addContactSuccess: true,
                                contact_group_contact: [],
                                admin_group_mapping_row_data: []
                            }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        addContactSuccess: false
                                    })
                                }, 1000)
                            })
                            Utility.toastNotifications(response[0].message, "Success", "success");
                        } else {
                            Utility.toastNotifications(response[0].message, "Error", "error");
                        }
                        loaderStateFalse();
                    }
                    loaderStateFalse();
                })
                .catch((error) => {
                    Utility.toastNotifications(error.message, "Error", "error");
                    loaderStateFalse();
                })
        } else {
            Utility.toastNotifications("Please select minimum one row", "Warning", "warning");
        }

    }

    remove_member_on_row = (memberValue) => {
        let customer_id = [memberValue.user_id]
        let contact_group_id = memberValue.group_id
        this.setState({
            remove_contact_group_contact_flag: true,
            remove_contact_on_row_flag: true,
            row_customer_id: customer_id,
            row_contact_group_id: contact_group_id,
        }, () => {
            // this.commonMemberRemove(customer_id, contact_group_id, "remove_member_on_row")
        })

    }

    removeContactGroupContact = () => {
        if (this.state.contact_group_contact.length > 0 && this.state.admin_group_mapping_row_data.length > 0) {
            this.setState({
                remove_contact_group_contact_flag: true,
                remove_group_contact_arr: this.state.admin_group_mapping_row_data
            })
        } else {
            this.setState({
                remove_contact_group_contact_flag: false,
                remove_group_contact_arr: [],
                contact_group_contact: [],
                admin_group_mapping_row_data: []
            })
            Utility.toastNotifications("Please select minimum one row", "Warning", "warning");
        }
    }

    remove_contact_group_contact_modal_hide = () => {
        //console.log("=========entry close")
        this.setState({
            remove_contact_group_contact_flag: false,
            remove_group_contact_arr: [],
            //contact_group_contact: [],
            remove_contact_on_row_flag: false,
            row_customer_id: [],
            row_contact_group_id: "",
        })
    }

    remove_contact_group_contact_confirm_button = () => {
        if (this.state.remove_contact_on_row_flag) {
            //console.log("entry==========0")
            this.commonMemberRemove(this.state.row_customer_id, this.state.row_contact_group_id, "remove_member_on_row")
        } else {
            this.remove_contact_group_contact_api()
        }

    }

    remove_contact_group_contact_cancle_button = () => {
        this.remove_contact_group_contact_modal_hide();
    }

    remove_contact_group_contact_api = () => {
        //console.log("entry remove_contact_group_contact_api=========")
        const { remove_group_contact_arr } = this.state;
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        this.commonMemberRemove(remove_group_contact_arr[0].user_id, remove_group_contact_arr[0].group_id, "");

    }

    commonMemberRemove = (ids, group_id, type) => {
        //console.log("entry commonMemberRemove=========")
        let data = {}
        data['id'] = ids
        data['group_id'] = group_id
        //console.log("data==========", data)
        //console.log("type==========", type)
        //return false;
        AdminGroupController.contact_group_contact_remove(data).then((response) => {
            if (response.success) {
                this.remove_contact_group_contact_modal_hide();
                if (type == "remove_member_on_row") {
                    this.setState({
                        //member
                        removeContactSuccess: true,
                        memberList: [],
                        memberLimits: 17,
                        memberOffsets: 0,
                        hasMoreMemberList: false,
                        //group
                        groupList: [],
                        groupLimits: 15,
                        groupOffsets: 0,
                        hasMoreGroupList: false,
                        selectedMemberRowId: ""
                    }, () => {
                        this.allGroupWiseMemberList();
                        this.listAllGroups();
                        setTimeout(() => {
                            this.setState({
                                removeContactSuccess: false,
                                remove_group_contact_arr: []
                            })
                        }, 1000)
                    })
                } else {
                    this.setState({
                        removeContactSuccess: true,
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                removeContactSuccess: false,
                                remove_group_contact_arr: [],
                                contact_group_contact: [],
                                admin_group_mapping_row_data: []
                            })
                        }, 1000)
                    })
                }
                Utility.toastNotifications(response.data[0].message, "Success", "success");
            } else {
                Utility.toastNotifications(response.data[0].message, "Error", "error");
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
            this.remove_contact_group_contact_modal_hide()
        });
    }

    handleUserSearchBar = (e) => {
        //console.log(e.target.name)
        const { select_all_Unsubscribe_row, searchMemberValue } = this.state
        // console.log("select_all_Unsubscribe_row=======", select_all_Unsubscribe_row)
        let inputValue = e.target.value.trim();
        // console.log("inputValue=======", inputValue)
        if (searchMemberValue.trim() != inputValue) {
            // if (inputValue) {
            if (e.target.value.length > 2) {
                this.setState({
                    searchMemberValue: e.target.value,
                    memberList: [],
                    memberLimits: 17,
                    memberOffsets: 0,
                    hasMoreMemberList: false,
                }, () => {
                    if (this.state.selectedGroupId != "") {
                        this.allGroupWiseMemberList();
                    } else {
                        if (select_all_Unsubscribe_row) {
                            this.fetchAllUnsubscribeContact()
                        } else {
                            this.fetchAllContact();
                        }
                    }
                });
            } else {
                this.setState({
                    searchMemberValue: e.target.value,
                    memberList: [],
                    memberLimits: 17,
                    memberOffsets: 0,
                    hasMoreMemberList: false,
                }, () => {
                    if (this.state.selectedGroupId != "") {
                        this.allGroupWiseMemberList();
                    } else {
                        if (select_all_Unsubscribe_row) {
                            this.fetchAllUnsubscribeContact()
                        } else {
                            this.fetchAllContact();
                        }

                    }
                });
            }
        }
    }

    removeSearchContactFn = () => {
        const { select_all_Unsubscribe_row } = this.state
        this.setState({
            searchMemberValue: "",
            memberList: [],
            memberLimits: 17,
            memberOffsets: 0,
            hasMoreMemberList: false,
        }, () => {
            if (this.state.selectedGroupId != "") {
                this.allGroupWiseMemberList();
            } else {
                if (select_all_Unsubscribe_row) {
                    this.fetchAllUnsubscribeContact()
                } else {
                    this.fetchAllContact();
                }

            }
        });

    }

    firstCheckUserLimit = () => {
        const { loaderStateTrue, loaderStateFalse, userCredentials } = this.props;
        let data = {};
        let globalQueryParamshash = {};
        globalQueryParamshash['org_id'] = userCredentials.user_details.org_id;
        data['filters'] = JSON.stringify(globalQueryParamshash);
        loaderStateTrue();
        const promise = new Promise((resolve, reject) => {
            AdminGroupController.checkUserLimit(data).then((response) => {
                // console.log("response========", response)
                if (response.success) {
                    this.setState({
                        checkLimitNote: response.message
                    }, () => {
                        this.addNewContact();
                    })
                } else {
                    Utility.toastNotifications(response.message, "Error", "error");
                }
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();
            });
        })
        return promise;
    }

    addNewContact = () => {
        this.setState({
            addNewContactFlag: true,
            showPopOver: false,
            showGroupContactPopOver: false,
            editedFlagUser: false,
            editedIdUser: ""
        })
    }
    // closeNewContact = () => {
    //     this.setState({
    //         addNewContactFlag: false,
    //         zoominzoomoutflag: false,
    //     })
    // }

    handleButtonClick = () => {
        this.setState({
            showPopOver: !this.state.showPopOver,
            showGroupContactPopOver: !this.state.showGroupContactPopOver
        });
    };

    handleSearchBarGridContact = (e) => {
        let inputValue = e.target.value.trim();
        if (inputValue != this.state.searchValue.trim()) {
            this.setState({
                searchValue: e.target.value.trim()
            }, () => {
                // console.log("aaaaaaaa=========>", this.state.contact_group_contact);
            })
        }
    }

    clearSearchValueGridContact = () => {
        this.setState({
            searchValue: ""
        })
    }

    getDimensions = () => {
        let headerHeight = 66;
        let footerHeight = 45;
        let pixcel = "px"
        let content = window.innerHeight - headerHeight - footerHeight
        let contentWidthPixcel = parseInt(content) + pixcel
        // console.log("headerHeight========", headerHeight)
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            contentHeight: contentWidthPixcel,
        });
    }

    addInputProfileImageChanged = (event) => {
    }

    isupdate = (data) => {
        this.setState({
            addNewContactFlag: data,
            editedFlagUser: true,
            //editedIdUser: this.state.clickedMemberData.id,
            editedIdUser: this.state.select_all_group_row ? this.state.clickedMemberData.id : this.state.clickedMemberData.user_id,
            //resert group
            groupList: [],
            groupLimits: 15,
            groupOffsets: 0,
            hasMoreGroupList: false,
            select_all_group_row: this.state.select_all_group_row ? true : false,
            selectedGroupId: this.state.select_all_group_row ? "" : this.state.activeGroupRow.id,
            //resert member
            memberList: [],
            memberLimits: 17,
            memberOffsets: !data ? this.state.memberLimits - this.state.memberOffsets : 0,
            hasMoreMemberList: false,
            select_all_Unsubscribe_row: false,
            select_all_default_user: false,
            //
            addNewContactFlag: false,
            zoominzoomoutflag: false,
            selectedMemberRowId: this.state.editedIdUser
        }, () => {
            this.listAllGroups();
            //this.fetchAllUserAdminData();

            if (this.state.select_all_group_row) {
                this.fetchAllUserAdminData();
            } else {
                this.allGroupWiseMemberList();
            }
        })
    }

    closeUserModal = (data) => {
        this.setState({
            addNewContactFlag: data,
            editedFlagUser: true,
            //editedIdUser: this.state.clickedMemberData.id,
            editedIdUser: this.state.select_all_group_row ? this.state.clickedMemberData.id : this.state.clickedMemberData.user_id,
            //resert group
            groupList: [],
            groupLimits: 15,
            groupOffsets: 0,
            hasMoreGroupList: false,
            select_all_group_row: true,
            selectedGroupId: "",
            //resert member
            memberList: [],
            memberLimits: 17,
            memberOffsets: 0,
            hasMoreMemberList: false,
            select_all_Unsubscribe_row: false,
            select_all_default_user: false,
            //
            addNewContactFlag: false,
            zoominzoomoutflag: false,
        }, () => {
            this.listAllGroups();
            this.fetchAllUserAdminData();
        })
    };

    checkTabInsideRole = async () => {
        let checkRules = await UtilityGlobal.getRoleObjectBySubEventKey('home', 'appUser');
        if (checkRules.length > 0) {
            this.setState({
                checkRulesPermission: checkRules[0]?.rules
            }, () => {
                // console.log("checkRulesPermission===========", this.state.checkRulesPermission)
            })
        }
    }

    render() {
        const { selectedMemberRowId, select_all_group_row, dataFor, select_all_Unsubscribe_row,
            select_all_default_user, default_user_count, checkLimitNote, checkRulesPermission } = this.state
        let roleName = this.props.userCredentials.hasOwnProperty('user_details') && this.props.userCredentials.user_details && this.props.userCredentials.user_details.hasOwnProperty('user_type') && this.props.userCredentials.user_details.user_type;
        return (
            <div className="gridcontainer all_group_contact_personal_information_container" >
                <div className='user_all_group_list_inner'>
                    <div className='user_all_group_header_section'>
                        {/* <div onClick={() => { this.fetchAllContact() }} className={`${select_all_group_row ? "active" : ""} all_contact_label all_contact_label_box`}>Groups</div> */}
                        <div className={`all_contact_label all_contact_label_box`}>Groups</div>
                        {/* {roleName != "user" ? */}
                        {((roleName == 'user' || roleName == 'staff') && (checkRulesPermission == "CRUD" || checkRulesPermission == "CUD")) || (roleName == 'admin') ?
                            <div className='group_section'>
                                <OverlayTrigger
                                    //show={this.state.showGroupContactPopOver}
                                    rootClose
                                    trigger="click"
                                    placement="bottom"
                                    overlay={
                                        <Popover className="group_single_action_inner group_contact_action_inner">
                                            <Popover.Content>
                                                <div className="group_action_row">
                                                    <button className="group_action_btn_popup" onClick={() => { this.firstCheckUserLimit() }}>
                                                        <span className='group_action_btn_popup_icon'><i className="fa fa-user-plus" ></i></span>
                                                        <span className='group_action_btn_popup_text'>New User</span>
                                                    </button>
                                                    <button className="group_action_btn_popup" onClick={this.contactGroupModalfunction}>
                                                        <span className='group_action_btn_popup_icon'><i className="fa fa-users" ></i></span>
                                                        <span className='group_action_btn_popup_text'>New Group</span>
                                                    </button>
                                                </div>
                                            </Popover.Content>
                                        </Popover>
                                    }
                                >
                                    <button type='button' className='group_add_button' onClick={this.handleButtonClick}><img src={require('../../../../Utility/Public/images/plus.png')} className='group_add_img' /></button>
                                </OverlayTrigger>
                            </div>
                            : null}
                    </div>
                    {/* <div onClick={() => { this.fetchAllUnsubscribeContact() }} className={`${select_all_Unsubscribe_row ? "active" : ""} all_contact_label`}>Unsubscribe Contact</div> */}
                    {/* <div onClick={() => { this.fetchAllDefaultUser() }} className={`${select_all_default_user ? "active" : ""} all_default_user`}>Default {default_user_count ? <span className='default_user_count'>{default_user_count}</span> : null}</div> */}
                    <div onClick={() => { this.fetchAllDefaultUser() }} className={`${select_all_group_row ? "active" : ""} all_default_user`}>Default {default_user_count ? <span className='default_user_count'>{default_user_count}</span> : null}</div>
                    <div id="scrollableDiv" className='user_all_group_list_scroll_box'>
                        <InfiniteScroll
                            dataLength={this.state.groupList.length}
                            next={this.getNextGroupData}
                            hasMore={this.state.hasMoreGroupList}
                            loader={<div className="text-center"><ScaleLoader className="fadeloader_property" color="#45c1ff" size={40} /></div>}
                            scrollableTarget="scrollableDiv"
                        >
                            {this.groupListUi()}
                        </InfiniteScroll>
                    </div>
                </div>
                <div className='user_all_contact_list_inner'>
                    <div className='search_all_contact_search_inner'>
                        <div className="pageinnersearch">
                            <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                            <DebounceInput
                                minLength={2}
                                debounceTimeout={500}
                                onChange={(e) => this.handleUserSearchBar(e)}
                                placeholder="Search All Users"
                                value={this.state.searchMemberValue}
                            />
                            {
                                this.state.searchMemberValue.length >= 2 ?
                                    < button type="button" className="btn btn-link dropclosebtn" onClick={this.removeSearchContactFn}>
                                        <img src={require('../../../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                                    </button>
                                    : null}
                        </div>
                    </div>
                    <div id="scrollableDivMember" className='user_all_contact_list_scroll_box'>
                        <InfiniteScroll
                            dataLength={this.state.memberList.length}
                            next={this.getNextMemberData}
                            //style={{ display: 'flex' }} //To put endMessage and loader to the top.
                            hasMore={this.state.hasMoreMemberList}
                            loader={<div className="text-center"><ScaleLoader className="fadeloader_property" color="#45c1ff" size={40} /></div>}
                            scrollableTarget="scrollableDivMember"
                        >
                            {this.memberListUi()}
                        </InfiniteScroll>
                    </div>
                </div>
                <div className='user_personal_information'>
                    {this.state.selectedMemberRowId != "" ?
                        <div className='contactGroupBox'>
                            <div className='user_personal_information_header_section'>
                                <div className='user_personal_information_title_lavel'>Edit User</div>
                                {roleName == "admin" && ((this.state.selectedGroupId == "" ? this.state.clickedMemberData.id : this.state.clickedMemberData.user_id) != this.props.userCredentials.id) ?
                                    <>
                                        <div className='user_delete' onClick={this.deleteUserFn}>
                                            <OverlayTrigger overlay={<Tooltip>Delete User</Tooltip>} placement="right">
                                                <i className="fa fa-trash-o delete_btn"></i>
                                            </OverlayTrigger>
                                        </div>
                                        <div className='toggleSwitchBox'>
                                            <div className='switch_btn_customize'>
                                                <BootstrapSwitchButton
                                                    onlabel='Active'
                                                    onstyle='success'
                                                    offlabel='Inactive'
                                                    offstyle='danger'
                                                    style={'w-60 mx-2'}
                                                    checked={this.state.clickedMemberData.status}
                                                    onChange={(e) => this.active_inactive_user(e)}
                                                    disabled={false}
                                                />
                                            </div>
                                        </div></> : null}
                                <div className='user_personal_information_close' onClick={this.closeUserInfoFn}>
                                    <i className="fa fa-close"></i>
                                </div>
                            </div>
                            <ErrorBoundary title="UserInformation component Error">
                                <AddEditUserGroupContent
                                    editedFlagUser={this.state.editedFlagUser}
                                    editedIdUser={this.state.editedIdUser}
                                    closeUserModal={this.closeUserModal}
                                    isupdate={this.isupdate}
                                    clickedMemberData={this.state.clickedMemberData}
                                />
                            </ErrorBoundary>
                        </div> : null}
                </div>
                {/*======= delete user ==========*/}
                <ModalGlobal
                    show={this.state.deleteUserModalFlag}
                    onHide={this.deleteUserConfirmationModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Delete this user?"
                    footer={false}
                    body={
                        <ConfirmationAlert
                            BodyFirstContent="Are you confirm delete the user?"
                            // BodySecondContent={this.state.adminGroupDeleteBodySecondContent.length >= 20 ? this.state.adminGroupDeleteBodySecondContent.substring(0, 20) + "..." : this.state.adminGroupDeleteBodySecondContent}
                            // BodyThirdContent="You won't be able to go back."
                            confirmationButtonContent="Confirm"
                            cancelButtonContent="Cancel"
                            deleteConfirmButton={this.userDeleteConfirmButton}
                            deleteCancleButton={this.userDeleteCancleButton}
                        />
                    }
                />
                {/*======= delete user ==========*/}

                <ModalGlobal
                    show={this.state.adminGroupModalFlag}
                    onHide={this.closeAdminGroupModal}
                    title={this.state.modalHeaderTitle}
                    className={`${this.state.modalReadOnly ? "modaldisabled" : ""} ${this.state.zoominzoomoutflag + ' ' + "modalcustomize mondimension contactGroupModal"}`}
                    footer={true}
                    closeButton={true}
                    zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary delconfirmbtn"
                    onSave={this.saveAdminGroup}
                    cancelShow={true}
                    zoomin={this.zoominFunction}
                    zoomout={this.zoomoutFunction}
                    onCancel={this.closeAdminGroupModal}
                    body={
                        <ContactGroupModalContent
                            handleChange={this.handleChange}
                            name={this.state.name}
                            name_error={this.state.name_error}
                        />
                    }
                />

                <ModalGlobal
                    show={this.state.deleteAdminGroupModalFlag}
                    onHide={this.deleteConfirmationModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Delete this admin group?"
                    footer={false}
                    body={
                        <ConfirmationAlert
                            BodyFirstContent="Do you confirm the deletion of the"
                            BodySecondContent={this.state.adminGroupDeleteBodySecondContent.length >= 20 ? this.state.adminGroupDeleteBodySecondContent.substring(0, 20) + "..." : this.state.adminGroupDeleteBodySecondContent}
                            BodyThirdContent="admin group definitely? You won't be able to go back."
                            confirmationButtonContent="Confirm"
                            cancelButtonContent="Cancel"
                            deleteConfirmButton={this.adminGroupDeleteConfirmButton}
                            deleteCancleButton={this.adminGroupDeleteCancleButton}
                        />
                    }
                />

                <ModalGlobal
                    show={this.state.addRemoveModalFlag}
                    onHide={this.closeAddRemoveModal}
                    title={`Add/Remove User ( ${this.state.getRowName} )`}
                    className={`${this.state.modalReadOnly ? "modaldisabled" : ""} ${this.state.zoominzoomoutflag + ' ' + "modalcustomize mondimension contactGroupModal contactGroupModalContent add_Remove_contacts_content"}`}
                    footer={true}
                    closeButton={true}
                    zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                    saveButtonLabel={dataFor == 'add_contacts' ? "Add" : "Remove"}
                    saveButtonClassName="btn btn-primary delconfirmbtn"
                    onSave={dataFor == 'add_contacts' ? this.saveContactGroupContact : this.removeContactGroupContact}
                    cancelShow={true}
                    zoomin={this.zoominFunction}
                    zoomout={this.zoomoutFunction}
                    onCancel={this.closeAddRemoveModal}
                    body={
                        <UserGroupComponent
                            columnDefs={this.state.columnDefsContactGroup}
                            //organizationFilterSelectedData={this.state.organizationFilterSelectedData}
                            onRowClicked={this.onRowClicked}
                            dataFor={this.state.dataFor}
                            tabsShow={true}
                            getRowId={this.state.getRowId}
                            showGridData={this.showGridData}
                            addContactSuccess={this.state.addContactSuccess}
                            removeContactSuccess={this.state.removeContactSuccess}
                            searchValue={this.state.searchValue}
                            contactGroupGrid={true}
                            contact_group_contact={this.state.contact_group_contact}

                            handleSearchBar={this.handleSearchBarGridContact}
                            clearSearchValue={this.clearSearchValueGridContact}
                        />
                    }
                />

                <ModalGlobal
                    show={this.state.remove_contact_group_contact_flag}
                    onHide={this.remove_contact_group_contact_modal_hide}
                    className="modalcustomize confirmationalertmodal removeConfirmation"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Remove this user from group?"
                    footer={false}
                    body={
                        <ConfirmationAlert
                            BodyFirstContent="Do you confirm the remove of the"
                            BodyThirdContent="user from group definitely?"
                            confirmationButtonContent="Confirm"
                            cancelButtonContent="Cancel"
                            deleteConfirmButton={this.remove_contact_group_contact_confirm_button}
                            deleteCancleButton={this.remove_contact_group_contact_cancle_button}
                        />
                    }
                />

                <ModalGlobal
                    show={this.state.addNewContactFlag}
                    onHide={this.closeUserModal}
                    title={<div className='addUserModalTitle'>
                        <span>Add User</span>
                        {checkLimitNote != "" && checkLimitNote != null ?
                            <span className={`${/\d/.test(checkLimitNote) ? "check_limit_note_success" : "check_limit_note_denger"}`}>{'(' + checkLimitNote + ')'}</span> : null}
                    </div>}
                    className={`${this.state.modalReadOnly ? "modaldisabled" : ""} ${this.state.zoominzoomoutflag + ' ' + "modalcustomize mondimension contactGroupModal add_contact_modal"}`}
                    footer={false}
                    closeButton={true}
                    zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary delconfirmbtn"
                    //onSave={this.saveUserInformationFn}
                    cancelShow={true}
                    zoomin={this.zoominFunction}
                    zoomout={this.zoomoutFunction}
                    onCancel={this.closeUserModal}
                    body={
                        <>
                            <AddEditUserGroupContent
                                editedFlagUser={this.state.editedFlagUser}
                                editedIdUser={this.state.editedIdUser}
                                closeUserModal={this.closeUserModal}
                                isupdate={this.isupdate}
                                clickedMemberData={this.state.clickedMemberData}
                                showSubmitBtn={this.state.editedIdUser == "" ? true : false}
                            />
                        </>

                    }
                />

            </div >
        );
    }
}


const mapStateToProps = (globalState) => {
    //console.log("globalState=======RND", globalState)
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        roleWisePermission: globalState.mainReducerData.roleWisePermission
    };
}

export default withRouter(connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp })
    (withTranslation()(UserGroup)));